import safeGtag from "./ga";

// Fires once per form per page load: visitor started filling a lead form.
const fired = new Set();

export const trackFormStart = (formName) => {
  if (fired.has(formName)) return;
  fired.add(formName);
  safeGtag("event", "form_start", { form_name: formName });
  try {
    if (typeof window !== "undefined" && typeof window.fbq === "function") {
      window.fbq("trackCustom", "FormStart", { form_name: formName });
    }
  } catch (err) {
    // analytics must never break the app
    console.debug("analytics(fbq FormStart) call skipped:", err?.message);
  }
};
